var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover.top",
          value: { customClass: "tooltip" },
          expression: "{ customClass: 'tooltip' }",
          modifiers: { hover: true, top: true },
        },
      ],
      staticClass: "table-cell-application",
      attrs: { title: _setup.tooltip },
    },
    [
      _setup.application === "Zephyr Dashboard"
        ? _c("img", {
            attrs: { src: _setup.zephyrDashboardLogo, alt: _setup.application },
          })
        : _setup.application === "Little Arms Launcher"
        ? _c("img", {
            attrs: {
              src: _setup.littleArmsLauncherLogo,
              alt: _setup.application,
            },
          })
        : _c("span", [_vm._v(_vm._s(_setup.application))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }